/**
 * Codes that differ between the EU's VAT vocabulary, which our country list
 * speaks, and ISO 3166-1 alpha-2, which external services expect.
 *
 * Mirrors Country::getIsoCountryCode() on the backend.
 */
const ISO_COUNTRY_CODES: Record<string, string> = {
    EL: 'GR',
};

/**
 * The ISO 3166-1 alpha-2 code, for services that reject the VAT spelling.
 * Stripe rejects Greece as 'EL' outright.
 */
export const toIsoCountryCode = (countryCode: string): string =>
    ISO_COUNTRY_CODES[countryCode.toUpperCase()] ?? countryCode;
